export default __webpack_public_path__ + "static/media/top-image.4621fde0.svg";